import React, { Component, Fragment } from 'react'
import {
  Button,
  Select,
  MenuItem,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Tabs,
  Tab,
  Grid,
  FormControl,
  TablePagination,
  TableFooter,
  IconButton,
  withStyles,
} from '@material-ui/core'
import Snackbar from '@material-ui/core/Snackbar'

import { weedMapList, Appcues } from '../../../utils/constants'
import { updateAtIndex, deleteAtIndex, convertArrayToOptions } from '../../../utils/array'

import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'
import WeedMapMenuListItem from './WeedMapMenuListItem'
import WeedMapMenuListItemV2 from './WeedMapMenuListItemV2'
import { EditableCheckbox, EditableReactSelect } from '../../common/EditableComponents'
import ModalDialog from '../../common/ModalDialog'
import PersistentDrawer from '../../common/PersistentDrawer'
import AddProductSync from './AddProductSync'
import SearchField from '../../common/SearchField'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'

const WeedMapMenuListItemEditable = EditableHOCWrapper(WeedMapMenuListItem)
const WeedMapMenuListItemV2Editable = EditableHOCWrapper(WeedMapMenuListItemV2)

class WeedMapMenuListContainer extends Component {
  timeout = null

  state = {
    newCategory: false,
    activeCategory: 0,
    weedmapCategory: '',
    selectedProductsMap: {},
    thirdPartyBrandId: 'CUSTOM',
    thirdPartyProductId: '',
    wmDiscoveryTag: '',
    wmTagGroup: '',
    wmTags: [],
    productsToSync: [],
    allselected: false,
    term: '',
    selectedWmTagGroups: [],
    selectedDiscoveryTags: [],
    loading: false,
    saved: false,
    page: 0,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100],
  }

  componentDidMount() {
    if (this.props.categoryLastModified != null && this.props.categoryList.length > 0) {
      this.handleCategoryChange('', 0)
    }
  }

  componentDidUpdate(nextProps, prevProps) {
    if (nextProps.version !== this.props.version && nextProps.version === 2) {
      const filteredCategories = nextProps.categoryList.filter((cat) => cat.active)

      const activeCategory = filteredCategories[0]

      const weedmapCategory = (activeCategory && activeCategory.wmCategory) || ''

      this.setState({
        weedmapCategory,
      })

      this.props.getThirdPartyBrands()
    }

    if (nextProps.categoryLastModified != this.props.categoryLastModified) {
      // eslint-disable-line
      this.handleCategoryChange('', 0)
    }
  }

  onSave = (index) => (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    const { categoryMapping = [], tagMapping = [], version = 1 } = this.props

    const mappingArray = version === 1 ? categoryMapping : tagMapping
    if (version === 1) {
      const newCategories = updateAtIndex(mappingArray, index, data)

      this.props.onSave(newCategories, afterOnSave)
    } else {
      const product = this.props.productsList.find((prod) => prod.id === data.productId)
      let weedmapInfo = { ...data, wmThreshold: (product && product.wmThreshold) || 0 }
      this.props.onSave([weedmapInfo], afterOnSave)
    }
  }

  onDelete = (index) => (data) => {
    const { categoryMapping = [], tagMapping = [], version = 1 } = this.props

    const mappingArray = version === 1 ? categoryMapping : tagMapping

    if (version === 1) {
      const newCategories = deleteAtIndex(mappingArray, index)

      this.props.onSave(newCategories, () => {})
    } else {
      // const dataToDelete = mappingArray[index];
      // this.props.updateWeedmapMapping([{...dataToDelete, deleted: true}]);
      this.props.disableWeedmapforProducts([data], () =>
        this.handleCategoryChange('', this.state.activeCategory),
      )
    }
  }

  validate = (data) => {
    const { version = 1 } = this.props

    if (!data.categoryId) {
      this.props.onError('Please choose a category')
      return false
    }

    if (version === 1 && !data.weedmapCategory) {
      this.props.onError('Please choose a weedmaps category')
      return false
    }

    return true
  }

  saveNewCategory = (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    const { categoryMapping = [], tagMapping = [], version = 1 } = this.props

    const mappingArray = version === 1 ? categoryMapping : tagMapping

    const categoryMappingCopy = [...mappingArray]
    if (version === 1) {
      categoryMappingCopy.push({ ...data, flowerType: null })

      this.props.onSave(categoryMappingCopy, afterOnSave)
    } else {
      this.props.onSave([data], afterOnSave)
    }

    this.setState({
      newCategory: false,
    })
  }

  openNewCategory = () => {
    Appcues.track('Adding New Menu Item for weedmaps')
    this.setState({
      newCategory: true,
    })
  }

  closeNewCategory = () => {
    this.setState({
      newCategory: false,
    })
  }

  handleCategoryChange = (event, activeCategory) => {
    const filteredCategories = this.props.categoryList.filter((category) => category.active)

    const weedmapCategory =
      (filteredCategories[activeCategory] && filteredCategories[activeCategory].wmCategory) || ''

    this.setState({
      activeCategory,
      weedmapCategory,
      productstoSync: [],
      selectedProductsMap: {},
    })
    this.props.updateCategory(
      filteredCategories[activeCategory] && filteredCategories[activeCategory].id,
    )
    this.props.getBLAZEProducts(
      filteredCategories[activeCategory] && filteredCategories[activeCategory].id,
    )
  }

  setWeedmapCategory = async (event) => {
    const { activeCategory } = this.state
    this.setState({ loading: true })

    const activeCategories =
      this.props.categoryList && this.props.categoryList.filter((category) => category.active)
    const categoryId =
      (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
    await this.props.performCategoryMapping(categoryId, event.target.value)
    this.props.getThirdPartyBrands()

    this.setState({
      weedmapCategory: event.target.value,
      loading: false,
      saved: true,
    })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ saved: false })
  }

  selectAll = (wmCategory) => (event) => {
    if (event.target.checked) {
      const { productsList = [], tagMapping = [], categoryList = [] } = this.props

      const { selectedProductsMap = {}, activeCategory } = this.state

      let updatedProductsMap = { ...selectedProductsMap }

      const activeCategories = categoryList.filter((category) => category.active)

      productsList
        .filter((product) => product.enableWeedmap)
        .forEach((product) => {
          const dataToEditIndex = tagMapping.findIndex((wmMap) => {
            return wmMap.productId === product.id
          })

          const dataToEdit = tagMapping[dataToEditIndex]

          const categoryId =
            (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
          if (dataToEdit) {
            if (!dataToEdit.thirdPartyProduct)
              updatedProductsMap = {
                ...updatedProductsMap,
                [product.id]: dataToEdit || {
                  wmTags: [(wmCategory && wmCategory.name) || ''],
                  productId: product.id,
                  categoryId,
                },
              }
          } else {
            updatedProductsMap = {
              ...updatedProductsMap,
              [product.id]: {
                wmTags: [(wmCategory && wmCategory.name) || ''],
                productId: product.id,
                categoryId,
              },
            }
          }
        })

      this.setState({
        selectedProductsMap: updatedProductsMap,
      })
    } else {
      this.setState({
        selectedProductsMap: {},
      })
    }
  }

  onRowCheck = (data, event) => {
    const { selectedProductsMap = {} } = this.state

    let updatedProductsMap = { ...selectedProductsMap }

    if (event.target.checked) {
      updatedProductsMap = { ...updatedProductsMap, [data.productId]: data }
    } else {
      delete updatedProductsMap[data.productId]
    }

    this.setState({
      selectedProductsMap: {
        ...updatedProductsMap,
      },
    })
  }

  bulkUpdateProducts = () => {
    Appcues.track('Updating Weedmaps Products')
    const { selectedProductsMap = {}, weedmapCategory = '' } = this.state

    if (!weedmapCategory) {
      return this.props.showError('Please select weedmaps category')
    }

    if (!Object.keys(selectedProductsMap).length) {
      return this.props.showError('Please select at least one product before proceeding')
    }
    this.bulkUpdateModal.handleClickOpen()
  }

  onClose = () => {
    this.setState({
      thirdPartyBrandId: 'CUSTOM',
      thirdPartyProductId: '',
      wmDiscoveryTag: '',
      wmTagGroup: '',
      wmTags: [],
      selectedWmTagGroups: [],
      selectedDiscoveryTags: [],
    })
  }

  onOpen = () => {
    this.props.getThirdPartyBrands()
  }

  setBulkUpdateChange = (key) => (event) => {
    const { value } = event.target
    this.setState({
      [key]: value,
    })

    switch (key) {
      case 'thirdPartyBrandId' /* if(value != 'CUSTOM')
                                            this.props.getWeedmapProducts('', value); */:
        this.setState({
          wmTags: [],
          wmTagGroup: '',
          wmDiscoveryTag: '',
          thirdPartyProductId: '',
        })
        break
      case 'thirdPartyProductId':
        break
      default:
        break
    }
  }

  setBulkUpdateTagsChange = (index) => (value) => {
    const { wmTags = [] } = this.state
    const updatedWmTags = [...wmTags]
    updatedWmTags[index] = value

    for (let i = index + 1; i < wmTags.length; ++i) {
      updatedWmTags[i] = ''
    }

    this.setState({
      wmTags: updatedWmTags,
    })
  }

  bulkUpdateMappedProducts = () => {
    Appcues.track('Updated Mapped Products for weedmaps')
    const { defaultTagMapping = {} } = this.props

    const {
      selectedProductsMap = {},
      thirdPartyBrandId = '',
      wmTags = [],
      weedmapCategory,
      selectedDiscoveryTags,
      selectedWmTagGroups,
    } = this.state

    const mainCategories =
      (defaultTagMapping['MAIN_CATEGORY'] && defaultTagMapping['MAIN_CATEGORY']['']) || []
    const wmCategory = mainCategories.find((cat) => cat.value === weedmapCategory)

    const productTagGroups = this.getProductTagGroups(selectedWmTagGroups, selectedDiscoveryTags)

    for (let i = 0; i < productTagGroups.length; ++i) {
      const tagGroup = productTagGroups[i]
      if (!tagGroup.wmDiscoveryTag) {
        this.props.showError(`Please select Discovery Tag for ${tagGroup.wmTagGroupName}`)
        return
      }
    }

    const data = Object.keys(selectedProductsMap).map((key) => {
      return {
        ...selectedProductsMap[key],
        thirdPartyBrandId,
        productTagGroups,
        wmTags: [(wmCategory && wmCategory.name) || '', ...wmTags.filter((tag) => tag)],
      }
    })

    this.props.onSave(data, () => {
      this.setState({
        selectedProductsMap: {},
      })
      this.bulkUpdateModal.handleClose()
    })
  }

  addProducts = () => {
    let { productsToSync = [], activeCategory, weedmapCategory } = this.state
    if (productsToSync && !productsToSync.length) {
      return this.props.showError('No product(s) selected!')
    }
    const activeCategories =
      this.props.categoryList && this.props.categoryList.filter((category) => category.active)

    const categoryId =
      (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
    //const categoryName = (activeCategories[activeCategory] && activeCategories[activeCategory].name) || '';
    this.addProductModal.handleClose()

    this.props.enableWeedmapforProducts(productsToSync, () =>
      this.handleCategoryChange('', this.state.activeCategory),
    )

    this.setState({
      productsToSync: [],
      allselected: false,
    })

    const mappedData = productsToSync.map((id, key) => {
      return {
        productId: id,
        categoryId: categoryId,
        wmTags: [weedmapCategory],
        thirdPartyBrandId: '',
        wmDiscoveryTag: '',
        wmTagGroup: '',
      }
    })
    Appcues.track('Weedmap Products Added')
    this.props.updateWeedmapMapping(mappedData)
  }

  removeProducts = (productId) => {}

  checkAllProducts = (e) => {
    const { productsList = [] } = this.props

    if (e.target.checked) {
      let products =
        (productsList &&
          productsList.filter((product, index) => {
            return !product.enableWeedmap
          })) ||
        []
      this.setState({
        productsToSync: products.map((prod) => prod.id),
        allselected: e.target.checked,
      })
    } else this.setState({ productsToSync: [], allselected: e.target.checked })
  }

  onCheckProduct = (productId) => {
    let { productsToSync = [], mapProducts = {} } = this.state
    if (!productsToSync.includes(productId)) {
      productsToSync.push(productId)
      mapProducts = { ...this.state.mapProducts, [productId]: true }
    } else {
      let index = productsToSync.findIndex((data) => data === productId)
      productsToSync.splice(index, 1)
      mapProducts = { ...this.state.mapProducts, [productId]: false }
    }

    this.setState({
      productsToSync,
      mapProducts,
    })
  }

  openMapProductModal = () => {
    const { productsList = [] } = this.props

    let length =
      productsList.filter((product) => {
        return !product.enableWeedmap
      }).length || 0
    if (length > 0) {
      this.addProductModal.handleClickOpen()
      this.setState({
        mapProducts: {},
        productsToSync: [],
        allselected: false,
      })
    } else {
      return this.props.showError('No product available to be mapped.')
    }
  }

  loadThirdPartyBrands = (term, callback) => {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      callback(null, { options: [{ label: 'Custom', value: 'CUSTOM' }] })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.getThirdPartyBrands(term).then((res) => {
        let options =
          (res &&
            res.values &&
            res.values.map((brand) => ({ ...brand, label: brand.name, value: brand.id }))) ||
          []
        options = [{ label: 'Custom', value: 'CUSTOM' }, ...options]
        callback(null, { options })
      })
    }, 500)
  }

  onChangeBrand = (brand) => {
    this.setBulkUpdateChange('thirdPartyBrandId')({
      target: { value: (brand && brand.value) || '' },
    })
  }

  onChangeTagGroup = (key) => (values) => {
    let { selectedWmTagGroups, selectedDiscoveryTags = [] } = this.state
    let productTagGroups = [] // eslint-disable-line
    this.setState({
      [key]: values || [],
    })
    if (key === 'selectedWmTagGroups') {
      let difference = selectedWmTagGroups.find((x) => !values.includes(x))
      if (difference) {
        selectedDiscoveryTags = selectedDiscoveryTags.filter(
          (discoveryTag) => discoveryTag.data.wmTagGroup != difference.value,
        ) // eslint-disable-line
        this.setState({
          selectedDiscoveryTags,
        })
      }
      productTagGroups = this.getProductTagGroups(values, selectedDiscoveryTags)
    } else {
      productTagGroups = this.getProductTagGroups(selectedWmTagGroups, values)
    }
  }

  getProductTagGroups = (tagGroups, discoveryTags) => {
    let productTagGroups = []
    tagGroups.forEach((tagGroup) => {
      const filteredDiscoveryTags = discoveryTags
        .filter((discoveryTag) => discoveryTag.data.wmTagGroup === tagGroup.value)
        .map((val) => ({
          wmTagGroup: val.data.wmTagGroup,
          wmTagGroupName: val.data.wmTagGroupName,
          wmDiscoveryTag: val.value,
          wmDiscoveryTagName: val.label,
        }))
      productTagGroups = [
        ...productTagGroups,
        ...(filteredDiscoveryTags.length
          ? filteredDiscoveryTags
          : [{ wmTagGroup: tagGroup.value, wmTagGroupName: tagGroup.label }]),
      ]
    })
    return productTagGroups
  }

  onChangeSearch = (e) => {
    this.props.onChangeSearchTerm(e)
    this.setState({ selectedProductsMap: {} })
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
  }

  render() {
    const {
      categoryMapping = [],
      categoryList = [],
      lastModified = null,
      permitted = false,
      version = 1,
      defaultTagMapping = {},
      tagMapping = [],
      productsList = [],
      brandsList = [],
      weedmapTags = [],
      thirdPartyProducts = {},
      thirdPartyBrands = [],
    } = this.props

    const {
      newCategory,
      activeCategory,
      weedmapCategory,
      selectedProductsMap = {},
      //thirdPartyBrandId,
      wmTags = [],
      selectedDiscoveryTags = [],
      selectedWmTagGroups = [],
      page,
      rowsPerPage,
      rowsPerPageOptions,
    } = this.state

    const mappingArray = version === 1 ? categoryMapping : tagMapping

    const mainCategories =
      (defaultTagMapping['MAIN_CATEGORY'] && defaultTagMapping['MAIN_CATEGORY']['']) || []

    const activeCategories = categoryList.filter((category) => category.active)

    const wmCategory = mainCategories.find((cat) => cat.value == weedmapCategory) // eslint-disable-line

    const wmCategorySelect = mainCategories.find(
      (cat) =>
        (activeCategories[activeCategory] && activeCategories[activeCategory].wmCategory) ==
        cat.value,
    )

    let discoveryTags = []

    selectedWmTagGroups.forEach((tagGroup) => {
      discoveryTags = [
        ...discoveryTags,
        ...(tagGroup.data.discoveryTags.map((tag) => ({
          ...tag,
          wmTagGroup: tagGroup.data.tagGroupId,
          wmTagGroupName: tagGroup.data.tagGroupName,
        })) || []),
      ]
    })

    const secondLevelCategories =
      (defaultTagMapping['SECOND_LEVEL'] &&
        defaultTagMapping['SECOND_LEVEL'][(wmCategory && wmCategory.name) || '']) ||
      []
    const thirdLevelCategories =
      (defaultTagMapping['THIRD_LEVEL'] && defaultTagMapping['THIRD_LEVEL'][wmTags[1] || '']) || []
    const weedmapProducts = productsList || []

    const activeProducts =
      productsList &&
      productsList
        .filter((product) => product.enableWeedmap)
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

    /* let selectedThirdPartyBrand = thirdPartyBrands.find(brand => brand.id === thirdPartyBrandId);

		if (thirdPartyBrandId === 'CUSTOM') {
			selectedThirdPartyBrand = { name: 'Custom', value: 'CUSTOM' }
		}	 */

    const weedmapContent = (
      <Grid className="category-rightside">
        <Grid container>
          <Grid item sm={12} md={12} lg={12} xs={12} className="desktop-show margin-bottom-small">
            <span>
              BLAZE Category:{' '}
              {(activeCategories[activeCategory] && activeCategories[activeCategory].name) || ''}
            </span>
          </Grid>
          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            xs={12}
            className="res-show blaze-category-dropdown margin-bottom-small"
          >
            <span>Blaze Category:</span>
            <Select
              value={activeCategory}
              onChange={(event) => this.handleCategoryChange(event, event.target.value)}
              MenuProps={{ className: 'no-backdrop-select' }}
            >
              {activeCategories.map((item, index) => {
                return (
                  <MenuItem key={index} value={index}>
                    {item.name}
                  </MenuItem>
                )
              })}
            </Select>
          </Grid>
          <Grid item sm={12} md={12} lg={12} xs={12} className="desktop-show margin-bottom-small">
            <span>WM Category: {(wmCategorySelect && wmCategorySelect.name) || ''}</span>
          </Grid>
          <Grid className="res-show weedmap-category-section" item sm={6} md={6} lg={6} xs={12}>
            <div className="weedmap-at-sec">
              <span>WM Category: </span>
              <Select
                value={weedmapCategory}
                onChange={this.setWeedmapCategory}
                MenuProps={{ className: 'no-backdrop-select' }}
                style={{ minWidth: 200, marginLeft: 10 }}
                disabled={true}
              >
                {mainCategories.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.name}
                    </MenuItem>
                  )
                })}
              </Select>
            </div>
          </Grid>
          <Grid className="weedmap-category-btn" item sm={12} md={12} lg={12} xs={12}>
            <Button
              className={`${
                weedmapProducts && weedmapProducts.length === 0
                  ? 'disabled-button'
                  : 'primary-button'
              } margin`}
              disabled={weedmapProducts && weedmapProducts.length === 0}
              onClick={this.openMapProductModal}
            >
              Add Product
            </Button>
            <Button className="primary-button margin" onClick={this.bulkUpdateProducts}>
              Bulk Edit
            </Button>
          </Grid>
        </Grid>
        <div className="table-scroll">
          <SearchField
            value={this.props.term}
            onChange={this.onChangeSearch}
            onSearch={this.props.onSearch}
          />
          <Table
            className={`${weedmapProducts.length < 5 ? 'reverse-select' : 'outof-counts-select'}`}
          >
            <TableHead>
              <TableRow>
                <TableCell className="first-checkbox-column">
                  <EditableCheckbox
                    checked={
                      !!(
                        Object.keys(selectedProductsMap).length &&
                        Object.keys(selectedProductsMap).length ===
                          productsList.filter((prod) => {
                            let flag = false
                            const mappedData = mappingArray.find((wmMap) => {
                              return wmMap.productId === prod.id
                            })
                            if (mappedData) {
                              if (!mappedData.thirdPartyProduct) {
                                flag = true
                              }
                            } else {
                              flag = true
                            }
                            return prod.enableWeedmap && flag
                          }).length
                      )
                    }
                    valueToRender={''}
                    editMode={true}
                    onChange={this.selectAll(wmCategory)}
                    className="table-cus-checkbox"
                  />
                </TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>WM Product</TableCell>
                <TableCell>Tag Group</TableCell>
                <TableCell>Discovery Tag</TableCell>
                <TableCell>Secondary Level</TableCell>
                <TableCell>Third Level</TableCell>
                {permitted ? <TableCell></TableCell> : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {activeProducts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  const dataToEditIndex = mappingArray.findIndex((wmMap) => {
                    return wmMap.productId === item.id
                  })

                  const dataToEdit = mappingArray[dataToEditIndex]

                  const categoryId =
                    (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''

                  return (
                    <WeedMapMenuListItemV2Editable
                      product={item}
                      onSave={
                        dataToEditIndex !== -1 ? this.onSave(dataToEditIndex) : this.saveNewCategory
                      }
                      dataToEdit={
                        (dataToEdit && {
                          ...dataToEdit,
                          thirdPartyBrandId: !dataToEdit.thirdPartyProduct
                            ? 'CUSTOM'
                            : dataToEdit.thirdPartyBrandId,
                        }) || {
                          wmTags:
                            wmCategory && wmCategory.name
                              ? [(wmCategory && wmCategory.name) || '']
                              : [],
                          productId: item.id,
                          categoryId,
                          thirdPartyBrandId: 'CUSTOM',
                        }
                      }
                      weedMapList={weedMapList}
                      categoryList={categoryList}
                      onCancel={this.closeNewCategory}
                      defaultEditMode={false}
                      version={version}
                      productsList={activeProducts.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )}
                      brandsList={brandsList}
                      weedmapTags={weedmapTags}
                      getWeedmapProducts={this.props.getWeedmapProducts}
                      getThirdPartyBrands={this.props.getThirdPartyBrands}
                      thirdPartyProducts={thirdPartyProducts}
                      weedmapCategory={wmCategory && wmCategory.name}
                      showError={this.props.showError}
                      thirdPartyBrands={thirdPartyBrands}
                      onRowCheck={this.onRowCheck}
                      selectedProductsMap={selectedProductsMap}
                      getThirdPartyProducts={this.props.getThirdPartyProducts}
                      lastModified={lastModified}
                      lastUpdateTime={lastModified}
                      index={index}
                      onDelete={this.onDelete(dataToEditIndex)}
                    />
                  )
                })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={6}
                  count={activeProducts.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                  rowsPerPageOptions={rowsPerPageOptions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Grid>
    )
    const productsToShow =
      productsList &&
      productsList.filter((product) => {
        return !product.enableWeedmap
      })

    this.state.productsToSync = this.state.productsToSync.filter((item) =>
      productsToShow.some((product) => product.id === item),
    )

    const isAllProductsSelectedToMap = productsToShow.length === this.state.productsToSync.length

    return (
      <Fragment>
        {version === 1 ? (
          <div className="table-scroll">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>BLAZE Categories</TableCell>
                  {version === 1 ? <TableCell>Weedmaps Categories</TableCell> : null}
                  {version === 2 ? (
                    <Fragment>
                      <TableCell>Main Category</TableCell>
                      <TableCell>Second Level</TableCell>
                      <TableCell>Third Level</TableCell>
                      <TableCell>Fourth Level</TableCell>
                    </Fragment>
                  ) : null}
                  {permitted ? <TableCell></TableCell> : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {mappingArray.map((menu, index) => {
                  return (
                    <WeedMapMenuListItemEditable
                      onSave={this.onSave(index)}
                      dataToEdit={menu}
                      lastModified={lastModified}
                      weedMapList={weedMapList}
                      categoryList={categoryList}
                      onDelete={this.onDelete(index)}
                      key={index}
                      version={version}
                      defaultTagMapping={defaultTagMapping}
                    />
                  )
                })}
                {newCategory ? (
                  <WeedMapMenuListItemEditable
                    onSave={this.saveNewCategory}
                    dataToEdit={{ wmTags: [] }}
                    lastModified={lastModified}
                    weedMapList={weedMapList}
                    categoryList={categoryList}
                    onCancel={this.closeNewCategory}
                    defaultEditMode={true}
                    version={version}
                    defaultTagMapping={defaultTagMapping}
                  />
                ) : null}
              </TableBody>
            </Table>
          </div>
        ) : null}
        {permitted && !newCategory && version === 1 ? (
          <Button
            className="primary-button addMoreButton margin-bottom-small"
            onClick={this.openNewCategory}
          >
            + Add More
          </Button>
        ) : null}
        {version === 2 ? (
          <Grid container>
            <div className="desktop-show">
              <PersistentDrawer
                drawerClass="category-drawer"
                headerTitle="Map Products"
                drawerTitle="Categories"
                drawerContent={
                  <Grid className="category-sidebar">
                    <Tabs
                      classes={{
                        flexContainer: 'category-tabs',
                        indicator: 'no-tab-indicator',
                      }}
                      textColor="primary"
                      value={activeCategory}
                      onChange={this.handleCategoryChange}
                    >
                      {activeCategories.map((category) => {
                        return <Tab classes={{ selected: 'active' }} label={category.name} />
                      })}
                    </Tabs>
                  </Grid>
                }
              >
                {weedmapContent}
              </PersistentDrawer>
            </div>
            <div className="res-show">
              <Fragment>{weedmapContent}</Fragment>
            </div>
          </Grid>
        ) : null}
        <ModalDialog
          title={'Update Products'}
          ref={(c) => (this.bulkUpdateModal = c)}
          onConfirm={this.bulkUpdateMappedProducts}
          onClose={this.onClose}
          onOpen={this.onOpen}
        >
          <FormControl fullWidth className="margin-bottom-small">
            <label className="modal-lable">Tag Group</label>
            <EditableReactSelect
              value={selectedWmTagGroups}
              onChange={this.onChangeTagGroup('selectedWmTagGroups')}
              valueToRender={
                (selectedWmTagGroups &&
                  selectedWmTagGroups.map((tagGroup) => tagGroup.data.tagGroupName).join(', ')) ||
                ''
              }
              editMode={true}
              MenuProps={{ className: 'no-backdrop-select' }}
              multi={true}
              options={convertArrayToOptions(weedmapTags, 'tagGroupName', 'tagGroupId')}
            />
          </FormControl>
          <FormControl fullWidth className="margin-bottom-small">
            <label className="modal-lable">Discovery Tag</label>
            <EditableReactSelect
              value={selectedDiscoveryTags}
              onChange={this.onChangeTagGroup('selectedDiscoveryTags')}
              valueToRender={
                (selectedDiscoveryTags &&
                  selectedDiscoveryTags
                    .map((discoveryTag) => discoveryTag.data.tagName)
                    .join(', ')) ||
                ''
              }
              editMode={true}
              MenuProps={{ className: 'no-backdrop-select' }}
              multi={true}
              options={convertArrayToOptions(discoveryTags, 'tagName', 'tagId')}
            />
          </FormControl>
          {!!secondLevelCategories.length && (
            <FormControl fullWidth className="margin-bottom-small">
              <label className="modal-lable">Secondary Level</label>
              <EditableReactSelect
                value={wmTags[1] || ''}
                onChange={this.setBulkUpdateTagsChange(1)}
                valueToRender={
                  (selectedDiscoveryTags &&
                    selectedDiscoveryTags
                      .map((discoveryTag) => discoveryTag.data.tagName)
                      .join(', ')) ||
                  ''
                }
                editMode={true}
                MenuProps={{ className: 'no-backdrop-select' }}
                options={convertArrayToOptions(secondLevelCategories, 'name', 'name')}
                simpleValue
              />
            </FormControl>
          )}
          {!!thirdLevelCategories.length && (
            <FormControl fullWidth className="margin-bottom-small">
              <label className="modal-lable">Third Level</label>
              <EditableReactSelect
                value={wmTags[2] || ''}
                onChange={this.setBulkUpdateTagsChange(2)}
                valueToRender={
                  (selectedDiscoveryTags &&
                    selectedDiscoveryTags
                      .map((discoveryTag) => discoveryTag.data.tagName)
                      .join(', ')) ||
                  ''
                }
                editMode={true}
                MenuProps={{ className: 'no-backdrop-select' }}
                options={convertArrayToOptions(thirdLevelCategories, 'name', 'name')}
                simpleValue
              />
            </FormControl>
          )}
        </ModalDialog>
        <ModalDialog
          title={'Choose Products to Add'}
          ref={(c) => (this.addProductModal = c)}
          onConfirm={this.addProducts}
          onOpen={this.onOpen}
          confirmText={'Add Product'}
          onClose={(e) => {
            this.props.onChangeSearchTerm({ target: { value: '' } })
            setTimeout(() => this.props.onSearch(), 500)
          }}
          rootClass="modal-choose-pro"
          maxWidth="xs"
        >
          <div className="table-scroll product-map-modal">
            <SearchField
              value={this.props.term}
              onChange={this.props.onChangeSearchTerm}
              onSearch={this.props.onSearch}
            />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="first-checkbox-column">
                    <EditableCheckbox
                      valueToRender={''}
                      editMode={true}
                      onChange={this.checkAllProducts}
                      className="table-cus-checkbox"
                      checked={isAllProductsSelectedToMap}
                    />
                  </TableCell>
                  <TableCell className="first-checkbox-column">Product Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productsToShow.map((product, index) => (
                  <AddProductSync
                    key={index}
                    product={product}
                    onCheckProduct={this.onCheckProduct}
                    // allselected={this.state.allselected}
                    allselected={isAllProductsSelectedToMap}
                    mapProducts={this.state.mapProducts}
                    productsToSync={this.state.productsToSync}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
        </ModalDialog>
        <Snackbar
          open={this.state.saved}
          autoHideDuration={2000}
          onClose={this.handleClose}
          message="Saved 👍"
          className="snackbar success"
        />
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    defaultTagMapping:
      (state.integrationReducer &&
        state.integrationReducer.weedmapAccount &&
        state.integrationReducer.weedmapAccount.defaultTagMapping) ||
      {},
  }
}

export default connect(mapStateToProps)(WeedMapMenuListContainer)

/* ------ PAGINATION ------ */
const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: 50,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
  TablePaginationActions,
)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/WeedMapMenuListContainer.js